export const COORDINATES_REGEX =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)[,;]\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

export const isValidCoordinatesValue = (coordinates: string) =>
  COORDINATES_REGEX.test(coordinates.replace(/\s/g, ""));
